import React, { Component } from 'react';
import firebase from 'firebase';
import { Provider } from 'react-redux';

import store from './lib/store';
import Root from './Root';
import { getLoggedInUser } from './services/auth/actions';
import firebaseConfig from './firebase';

class App extends Component {
  constructor(props) {
    super(props);
    firebase.initializeApp(firebaseConfig);
  }

  componentWillMount() {
    store.dispatch(getLoggedInUser())
  }

  render() {
    return (
      <Provider store={store}>
        <Root />
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js